import './TypeAccountQuiz.css';
import '../../chaptercontainer.css'


const TypeAccountQuiz = ({
  question,
  selectedAnswer,
  isAnswerChecked,
  onSelectAnswer
}) => {
  const rawStatement = String(
    question?.statement || ''
  ).trim();

  const accountNumber = String(
    question?.accountNumber || ''
  ).trim();

  const hasAccountPrefix =
    accountNumber &&
    rawStatement.startsWith(accountNumber);

  const displayStatement =
    accountNumber && !hasAccountPrefix
      ? `${accountNumber} ${rawStatement}`.trim()
      : rawStatement;

  const options = ['Activ', 'Pasiv'];

  return (
    <div className="quiz-content-scroll-bc">


      <div className="type-account-card">

        <div className="type-account-statement-wrapper">
          <p
            className="type-account-statement"
            dangerouslySetInnerHTML={{
              __html: displayStatement
            }}
          />
        </div>

        <p className="type-account-label">
          este cont de:
        </p>

        <div className="type-account-options">
          {options.map((option) => {
            let optionClass =
              'type-account-option';

            if (isAnswerChecked) {
              if (
                option === question.correctType
              ) {
                optionClass +=
                  ' type-account-option--correct';
              } else if (
                option === selectedAnswer
              ) {
                optionClass +=
                  ' type-account-option--incorrect';
              }
            } else if (
              option === selectedAnswer
            ) {
              optionClass +=
                ' type-account-option--selected';
            }

            return (
              <button
                key={option}
                type="button"
                className={optionClass}
                onClick={() =>
                  onSelectAnswer(option)
                }
                disabled={isAnswerChecked}
              >
                {option}
              </button>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default TypeAccountQuiz;